import IconMi from 'components/common/icon/IconMi';
import IconHandler from 'components/common/icon/IconHandler';
import { IDomain } from 'store/conciergeSlice';
import { Box, Stack, Typography } from '@mui/material';
import { merge } from 'lodash';
import { ICustomStyles } from 'app/concierge/panel';
import defaultStyles from '../styles';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export default function DomainBadge({
    domain,
    selectDomain,
}: {
    domain: IDomain;
    selectDomain: (name: string) => void;
}) {
    const customStyles = useSelector((state: any) => state.concierge.customStyles) as ICustomStyles;

    const styles = useMemo(() => {
        return merge({}, defaultStyles, customStyles?.footerDomainSelector) as typeof defaultStyles;
    }, [customStyles]);

    const iconProps = {
        type: domain.icon_ind,
        value: domain.icon_ind === 'upload' ? `data:image/png;base64,${domain.icon_data}` : domain.icon_name,
    };

    return (
        <Stack direction={'row'} alignItems={'center'} sx={styles.domainBadge}>
            <IconHandler icon={iconProps} sx={{ fontSize: '16px' }} />
            <Typography>{domain.title}</Typography>
            {domain.name > '' && (
                <Box sx={styles.closeIcon} onClick={() => selectDomain(domain.name)}>
                    <IconMi icon={'times'} fontSize="16" />
                </Box>
            )}
        </Stack>
    );
}
